import { useObjectSelected } from '@domain/object-selected';
import { useSelector } from 'react-redux';
import { createGetFiltersState } from './filters.state';

export const useCampaignFilters = () => {
    const { selected } = useObjectSelected();
    const filters = useSelector(createGetFiltersState(selected.type, selected?.id));

    return {
        filters,
    };
};
